export default "__VITE_PUBLIC_ASSET__3c98ba22__"